/**
 * Normaliza datos de actuación para crear/actualizar API (misma lógica que guardar en detalle).
 * @param {Record<string, unknown>} form
 * @param {boolean} ubicLlegadaDistinta
 */
export function buildActuacionDatosPayload(form, ubicLlegadaDistinta) {
  // cartelUrl solo se gestiona con POST/DELETE /cartel, no con PATCH genérico
  const { cartelUrl: _omitCartel, ...formRest } = form || {};
  const lat = formRest.lat;
  const lng = formRest.lng;
  const latFin = formRest.latFin;
  const lngFin = formRest.lngFin;
  const necesidadAutobus = Boolean(formRest.necesidadAutobus);
  return {
    ...formRest,
    lat: lat === '' || lat == null || Number.isNaN(Number(lat)) ? null : Number(lat),
    lng: lng === '' || lng == null || Number.isNaN(Number(lng)) ? null : Number(lng),
    horaInicio: formRest.horaInicio?.trim?.() ? formRest.horaInicio.trim() : null,
    horaFin: formRest.horaFin?.trim?.() ? formRest.horaFin.trim() : null,
    uniforme: formRest.uniforme?.trim?.() ? formRest.uniforme.trim() : null,
    plantillaId: formRest.plantillaId && String(formRest.plantillaId).trim() !== '' ? formRest.plantillaId : null,
    necesidadAutobus,
    ...(necesidadAutobus
      ? {
          autobusUbicacion: formRest.autobusUbicacion?.trim?.() ? formRest.autobusUbicacion.trim() : null,
          autobusHoraSalida: formRest.autobusHoraSalida?.trim?.() ? formRest.autobusHoraSalida.trim() : null,
          autobusLat:
            formRest.autobusLat === '' || formRest.autobusLat == null || Number.isNaN(Number(formRest.autobusLat))
              ? null
              : Number(formRest.autobusLat),
          autobusLng:
            formRest.autobusLng === '' || formRest.autobusLng == null || Number.isNaN(Number(formRest.autobusLng))
              ? null
              : Number(formRest.autobusLng),
        }
      : { autobusUbicacion: null, autobusHoraSalida: null, autobusLat: null, autobusLng: null }),
    ...(ubicLlegadaDistinta
      ? {
          ubicacionFin: formRest.ubicacionFin?.trim?.() ? formRest.ubicacionFin.trim() : null,
          latFin: latFin === '' || latFin == null || Number.isNaN(Number(latFin)) ? null : Number(latFin),
          lngFin: lngFin === '' || lngFin == null || Number.isNaN(Number(lngFin)) ? null : Number(lngFin),
        }
      : { ubicacionFin: null, latFin: null, lngFin: null }),
  };
}
